/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Filters/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TasksFilters from 'DesignSystem/TasksFilters/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Filters({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Filters"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedBoardIdsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'board_ids',
})
let selectedFiltersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'filters',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Filters.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Wv2Qg': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-2-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Wv2Qg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TasksFilters
  viewPath={`${viewPath}/TasksFilters`}
 onChange={onChange}
 data="selected.board_ids"
 boardId={selectedBoardIdsValueData}
 data="selected.filters"
 syncFilters={selectedFiltersValueData}
/>
</div>
{children}
</React.Fragment>)
}